export default __webpack_public_path__ + "static/media/very-disappointed.3f61ed01.svg";